import {API_URL} from '../../../../resources/api';

export const winLosesURL : string = `${API_URL}dashboard/hostess/winloses`;
export const rankURL : string = `${API_URL}dashboard/hostess/rank`;
export const resumeURL : string = `${API_URL}dashboard/hostess/resume`;